var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdjustBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cancel/close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-100.0%",
    y: "-100.0%",
    width: "300.0%",
    height: "300.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.10432146 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Position",
    transform: "translate(-803.000000, -245.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cancel/close",
    transform: "translate(803.000000, 245.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000000",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.60002143,11.6015888 L13.6597021,11.6015888 C13.9436277,12.9992326 15.1730272,14.0036501 16.5998071,14.0036501 C18.0265871,14.0036501 19.2559865,12.9992326 19.5399121,11.6015888 L21.3999786,11.6015888 C21.7313613,11.6015888 22,11.3330654 22,11.001825 C22,10.6705847 21.7313613,10.4020613 21.3999786,10.4020613 L19.5399121,10.4020613 C19.2559865,9.00441749 18.0265871,8 16.5998071,8 C15.1730272,8 13.9436277,9.00441749 13.6597021,10.4020613 L8.60002143,10.4020613 C8.26863874,10.4020613 8,10.6705847 8,11.001825 C8,11.3330654 8.26863874,11.6015888 8.60002143,11.6015888 Z M16.5998071,9.20253383 C17.5939552,9.20253383 18.3998714,10.0081039 18.3998714,11.001825 C18.3998714,11.9955461 17.5939552,12.8011162 16.5998071,12.8011162 C15.6056591,12.8011162 14.7997428,11.9955461 14.7997428,11.001825 C14.7997428,10.5246233 14.9893919,10.0669666 15.3269695,9.72953402 C15.664547,9.39210147 16.1224004,9.20253383 16.5998071,9.20253383 L16.5998071,9.20253383 Z M21.3999786,18.3984113 L16.3402979,18.3984113 C16.0563722,17.0007675 14.8269728,15.99635 13.4001929,15.99635 C11.973413,15.99635 10.7440135,17.0007675 10.4600879,18.3984113 L8.60002143,18.3984113 C8.26863874,18.3984113 8,18.6669346 8,18.998175 C8,19.3294154 8.26863874,19.5979387 8.60002143,19.5979387 L10.4600879,19.5979387 C10.7440135,20.9955825 11.973413,22 13.4001929,22 C14.8269728,22 16.0563722,20.9955825 16.3402979,19.5979387 L21.3999786,19.5979387 C21.7313613,19.5979387 22,19.3294154 22,18.998175 C22,18.6669346 21.7313613,18.3984113 21.3999786,18.3984113 Z M13.4001929,20.7974662 C12.6721348,20.7974662 12.0157661,20.359083 11.7371503,19.6867339 C11.4585346,19.0143849 11.6125404,18.2404777 12.1273552,17.725884 C12.64217,17.2112903 13.4164097,17.0573506 14.0890476,17.3358467 C14.7616856,17.6143428 15.2002572,18.2704296 15.2002572,18.998175 C15.2002572,19.9918961 14.3943409,20.7974662 13.4001929,20.7974662 L13.4001929,20.7974662 Z",
    id: "\\u5F62\\u72B6",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdjustBlack);
export default __webpack_public_path__ + "static/media/adjust-black.c694dd8a9b4a20c772d43443ef56ccd4.svg";
export { ForwardRef as ReactComponent };